import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_CREATE_TASK_ARTICLE_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateTaskModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('CreateTaskModal');
  return /*#__PURE__*/_jsx(LearnMoreModal, {
    footer: /*#__PURE__*/_jsx(Link, {
      external: true,
      href: KNOWLEDGE_BASE_CREATE_TASK_ARTICLE_URL,
      onClick: () => trackLink('create task article'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.createTask.heading"
    }),
    illustrationName: "task",
    onClose: onClose,
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.createTask.description"
      })
    })
  });
};
CreateTaskModal.propTypes = {
  onClose: PropTypes.func
};
export default CreateTaskModal;